export default "__VITE_ASSET__Bom5qAX1__"